var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.category
    ? _c(
        "div",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.$i18nHelpers.normalize(_vm.category.name)))
            ])
          ]),
          _vm._v(" "),
          _vm.microhabits.length > 0 && _vm.patientMicrohabits !== null
            ? _c(
                "b-row",
                {
                  staticClass: "neu-cards-ctn landing-cnt  mt-5",
                  attrs: { cols: "1", "cols-xl": "4" }
                },
                _vm._l(_vm.microhabits, function(microhabit) {
                  return _c(
                    "div",
                    { key: microhabit.id },
                    [
                      !_vm.getPatientMicrohabit(microhabit)
                        ? _c("PatientPanelServiceBlock", {
                            class: {
                              "taller-neu-card": !!_vm.getMicrohabitDescription(
                                microhabit
                              )
                            },
                            attrs: {
                              visible: "",
                              id: microhabit.id,
                              title: _vm.$i18nHelpers.normalize(
                                microhabit.name
                              ),
                              description: _vm.getMicrohabitDescription(
                                microhabit
                              ),
                              action: function() {
                                _vm.onBlockClick(_vm.category, microhabit)
                              },
                              img:
                                microhabit.icon || _vm.DEFAULT_MICROHABIT_IMAGE,
                              noBackgroundImage: "",
                              toggleableMobileDescription:
                                _vm.isFoodMicrohabitType,
                              actionable: _vm.isFoodMicrohabitType
                            },
                            scopedSlots: _vm._u(
                              [
                                !_vm.isFoodMicrohabitType
                                  ? {
                                      key: "absolute-items",
                                      fn: function() {
                                        return [
                                          _c("BIconHeart", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                value: _vm.$t(
                                                  "microhabits.simple.panel-menu.add-to-my-habits"
                                                ),
                                                expression:
                                                  "$t('microhabits.simple.panel-menu.add-to-my-habits')",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass:
                                              "position-absolute heart-microhabit",
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.addToFavorites(
                                                  microhabit
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  : null
                              ],
                              null,
                              true
                            )
                          })
                        : _c("PatientMicrohabitBlock", {
                            attrs: {
                              patientMicrohabit: _vm.getPatientMicrohabit(
                                microhabit
                              ),
                              mainCategory: _vm.category,
                              showHeartIcon: "",
                              noBackgroundImage: "",
                              type: _vm.type,
                              img:
                                microhabit.icon || _vm.DEFAULT_MICROHABIT_IMAGE
                            },
                            on: { deleted: _vm.loadPatientMicrohabits }
                          })
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e43c6fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e43c6fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/microhabits/MicrohabitsPanelMenu.vue
// module id = 3138
// module chunks = 64 65